const items = [
  {
    text: 'Availability',
    megaMenu: true,
    subnav: [
      {
        text: 'A-D',
        subnav: [
          { text: 'Alabama', href: '/availability/al' },
          { text: 'Alaska', href: '/availability/ak' },
          { text: 'Arizona', href: '/availability/az' },
          { text: 'Arkansas', href: '/availability/ar' },
          { text: 'California', href: '/availability/ca' },
          { text: 'Colorado', href: '/availability/co' },
          { text: 'Connecticut', href: '/availability/ct' },
          { text: 'Delaware', href: '/availability/de' },
        ],
      },
      {
        text: 'F-L',
        subnav: [
          { text: 'Florida', href: '/availability/fl' },
          { text: 'Georgia', href: '/availability/ga' },
          { text: 'Hawaii', href: '/availability/hi' },
          { text: 'Idaho', href: '/availability/id' },
          { text: 'Illinois', href: '/availability/il' },
          { text: 'Indiana', href: '/availability/in' },
          { text: 'Iowa', href: '/availability/ia' },
          { text: 'Kansas', href: '/availability/ks' },
          { text: 'Kentucky', href: '/availability/ky' },
          { text: 'Louisiana', href: '/availability/la' },
        ],
      },
      {
        text: 'M',
        subnav: [
          { text: 'Maine', href: '/availability/me' },
          { text: 'Maryland', href: '/availability/md' },
          { text: 'Massachusetts', href: '/availability/ma' },
          { text: 'Michigan', href: '/availability/mi' },
          { text: 'Minnesota', href: '/availability/mn' },
          { text: 'Mississippi', href: '/availability/ms' },
          { text: 'Missouri', href: '/availability/mo' },
          { text: 'Montana', href: '/availability/mt' },
        ],
      },
      {
        text: 'N-O',
        subnav: [
          { text: 'Nebraska', href: '/availability/ne' },
          { text: 'Nevada', href: '/availability/nv' },
          { text: 'New Hampshire', href: '/availability/nh' },
          { text: 'New Jersey', href: '/availability/nj' },
          { text: 'New Mexico', href: '/availability/nm' },
          { text: 'New York', href: '/availability/ny' },
          { text: 'North Carolina', href: '/availability/nc' },
          { text: 'North Dakota', href: '/availability/nd' },
          { text: 'Ohio', href: '/availability/oh' },
          { text: 'Oklahoma', href: '/availability/ok' },
          { text: 'Oregon', href: '/availability/or' },
        ],
      },
      {
        text: 'P-W',
        subnav: [
          { text: 'Pennsylvania', href: '/availability/pa' },
          { text: 'Rhode Island', href: '/availability/ri' },
          { text: 'South Carolina', href: '/availability/sc' },
          { text: 'South Dakota', href: '/availability/sd' },
          { text: 'Tennessee', href: '/availability/tn' },
          { text: 'Texas', href: '/availability/tx' },
          { text: 'Utah', href: '/availability/ut' },
          { text: 'Vermont', href: '/availability/vt' },
          { text: 'Virginia', href: '/availability/va' },
          { text: 'Washington', href: '/availability/wa' },
          { text: 'West Virginia', href: '/availability/wv' },
          { text: 'Wisconsin', href: '/availability/wi' },
          { text: 'Wyoming', href: '/availability/wy' },
        ],
      },
    ],
  },
  {
    text: 'Customer Service',
    href: 'https://www.usdish.com/customer-service',
  },
]

export default items
